import { date, object } from "yup";
import { stringDefaultToEmpty } from "@poseidon/utils/yupSchemaTypes";
import { transformDateForYup } from "@poseidon/utils/yup";

export const boatSchema = object({
  engineType: stringDefaultToEmpty,
  engineNumber: stringDefaultToEmpty,
  hin: stringDefaultToEmpty,
  homeMarina: stringDefaultToEmpty,
  insuranceExpiryDate: date(),

  make: stringDefaultToEmpty,
  model: stringDefaultToEmpty,

  officialNumber: stringDefaultToEmpty,
  type: stringDefaultToEmpty,
  yearBuilt: stringDefaultToEmpty,

  createdAt: date().transform(transformDateForYup),
  updatedAt: date().transform(transformDateForYup),
});
